import { getEditLocation } from "../../../core/util/functions";
export const disputesLocation = "/cliring/disputedsituations";
export const getDisputesEditLocation = (id?: string) =>
  getEditLocation(disputesLocation, undefined, id);

export const editRouter = getDisputesEditLocation(":dispId?");
